import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/styles/index.css'
import "@fortawesome/fontawesome-free/css/all.min.css";
// import "@/assets/styles/tailwind.css";


createApp(App).use(router).mount('#app')
